import ProMembershipPrompt from '@jobseeker/feature-payment/components/ProMembershipPlanPopup';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import type {ProMembershipPromptType} from '@jobseeker/feature-payment/components/ProMembershipPlanPopup/types';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';

const ProMembershipPlanPopUp = (props: ProMembershipPromptType) => {
  const interceptor: any = useInterceptor();
  const profile = useSelector((state: AppState) => state.user.profile);
  const showRecruiterActions = profile?.proMembershipFeatures?.statusChange || false;
  const {
    proMembership: {planPopUp},
  } = interceptor;
  return <ProMembershipPrompt planPopUp={planPopUp} showRecruiterActions={showRecruiterActions} {...props} />;
};

export default ProMembershipPlanPopUp;
